define('braccessible.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('braccessible', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section class=\"braccessible-info-card\"><span class=\"braccessible-info-card-content\"></span></section> ";
},"useData":true}, 'extensions/BTM/BRAccessible/1.1.0/', 'extensions/BTM/BRAccessible/1.1.0/', Handlebars);
});